import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 0px 20px 10px;
  border-bottom: 1px solid #ebebf0;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  @media only screen and (max-width: 768px) {
    justify-content: space-between;
    padding: 0 0 10px 0;
    margin-bottom: 10px;
    span {
      font-family: 'Roboto';
      font-size: 20px;
    }
    #btnBack {
      display: none !important;
    }
  }
`;

export const Group = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const GroupBox = styled.div`
    display: flex;
    flex-direction: column;
`;

export const MonthInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 700px;
`;
